module.exports = __webpack_public_path__ + "img/march_madness_ss.d42e296e.png";